import React, {
  useState,
  useContext,
  useEffect,
  useCallback,
  useRef,
  useMemo,
} from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import moment from "moment";
import "../../../Resume-Upload/ResumeUpload.css";
import "./CreateClient.css";
import Table from "../../../../Common/Table/Table";
import Button from "../../../../Common/Button/Button";
import uploadIcon from "../../../../Assets/Images/resume-upload-icon.png";
import viewCandidateIcon from "../../../../Assets/Images/candidate-view.png";
import editIcon from "../../../../Assets/Images/edit-track-icon.svg";
import deleteIcon from "../../../../Assets/Images/delete-red-icon.png";
import accountIcon from "../../../../Assets/Images/accountIcon.png";
import jobIcon from "../../../../Assets/Images/jobTypeIcon.png";
import mailIcon from "../../../../Assets/Images/mail_icon.png";
import phoneIcon from "../../../../Assets/Images/phone_icon.png";
import locationIcon from "../../../../Assets/Images/location-icon_blue.svg";
import locationViewIcon from "../../../../Assets/Images/location_icon.svg";
import CustomTooltip from "../../../../Common/Tooltip/Tooltip";
import FileIcon from "../../../../Common/Common-Function/IconMapping.js";
import { Toast } from "../../../../Common/Toast-Snackbar/ToastSnackbar.js";
import SidePopup from "../../../../Common/SidePopup/SidePopup.js";
import DynamicTextField from "../../../../Common/Textfield/Textfield";
import TextInput from "../../../../Common/TextInput/TextInput";
import PhoneNumberInput from "../../../../Common/PhoneNumberInput/PhoneNumberInput";
import ContentDialog from "../../../../Common/Content-Dialog/ContentDialog.js";
import { ConfirmationPopup } from "../../../../Common/PopupStyles/PopupComponent.js";
import JobsDetailsContainer from "../../../../Common/Jobs-Details-Container/JobsDetailsContainer.js";
import { JobStatusUpdatePopup } from "../../../../Common/Card/JobsCard";
import DotLoader from "../../../../Common/Pre-Loader/DotLoader.jsx";
import { DynamicContext } from "../../../../Context/DynamicContext.js";
import { get, post, put, deleteRequest } from "../../../../helper/Api_helper.js";
import {
  VYLABS_BASE_URL,
  GET_CLIENT_DETAILS,
  UPDATE_CLIENT_INFO,
  DELETE_CLIENT_DETAILS,
  CREATE_CLIENT_CONTACT,
  UPDATE_CLIENT_CONTACT,
  DELETE_CLIENT_CONTACT,
  GET_RECRUITER_BY_ID,
  CREATE_CLIENT_TRACKING,
  CALLBACK_REMAINDERS,
  CALLBACK_REMAINDERS_CREATE,
  CALLBACK_REMAINDERS_DELETE,
  CALLBACK_REMAINDERS_UPDATE,
  GET_JOB_LIST_BY_CLIENT,
  GET_JOB_DETAILS_BY_ID,
  SIMPLE_SEARCH_CANDIDATES,
  GET_CANDIDATE_BY_ID,
  UPDATE_JOB,
  DELETE_JOB_DETAILS as DELETE_JOB,
} from "../../../../helper/url_helper.js";
import {
  formatDate,
  applyEllipsis,
  handleTriggerClear,
  handleCustomTrim,
} from "../../../../Common/Common-Function/CommonFunctions.js";
import OptionsData from "../../../../Assets/Json/StaticOptions.json";
import { candidatesCache } from "../../Jobs/RecommendCandidates.js";
import ClientDocuments from "./ClientDocuments.js";
import ClientJobs from "./ClientJobs";
import ClientTracking from "./ClientTracking";
import ClientAdditionalContacts from "./ClientAdditionalContacts";

function ClientXLResults(props) {
  const { isDarkMode, userDetails, MemberAccess, isHiringTeamTenant } =
    useContext(DynamicContext);
  const {
    spreadsheetResults,
    setUploadedResumes,
    showHeader,
    UploadedResumes,
    setSpreadsheetResults,
    failedSpreadsheets = [],
    setFailedSpreadsheets,
    resetSpreadsheetState,
  } = props || {};

  const { StaticOptions = {} } = OptionsData || {};
  const tenantLabel = isHiringTeamTenant ? "Hiring Team" : "Client";
  const tenantLabelLower = isHiringTeamTenant ? "hiring team" : "client";
  const { clientStatus = [], hiringTeamStatus = [] } = StaticOptions;
  const { clientPriority = [] } = StaticOptions;
  const activeClientStatusOptions = isHiringTeamTenant
    ? hiringTeamStatus
    : clientStatus;

  // Client SidePopup states
  const [viewClient, setViewClient] = useState(false);
  const [selectedClient, setSelectedClient] = useState(null);
  const [changedClient, setChangedClient] = useState({});
  const [clientCreatedUserName, setClientCreatedUserName] =
    useState("Loading...");
  const [isEditingClient, setIsEditingClient] = useState(false);
  const [isClientDeleteDialogOpen, setIsClientDeleteDialogOpen] =
    useState(false);
  const [activeTab, setActiveTab] = useState("Jobs");

  // Contact Dialog states
  const [selectedContact, setSelectedContact] = useState(null);
  const [selectedContactId, setSelectedContactId] = useState("");
  const [contactOptions, setContactOptions] = useState([]);
  const [showClientContactPopup, setShowClientContactPopup] = useState(false);
  const [showEditContactPopup, setShowEditContactPopup] = useState(false);
  const [showDeleteContactPopup, setShowDeleteContactPopup] = useState(false);
  const [isEditingContact, setIsEditingContact] = useState(false);
  const [isViewingContact, setIsViewingContact] = useState(false);

  // Tracking states
  const [trackingRefreshKey, setTrackingRefreshKey] = useState(0);
  const [clearTriggered, setClearTriggered] = useState(false);
  const [showReminderDialog, setShowReminderDialog] = useState(false);
  const [callbackRemainderRes, setCallbackRemainderRes] = useState([]);

  // Client Jobs states
  const clientJobsListObserver = useRef();
  const [clientJobsList, setClientJobsList] = useState([]);
  const [clientJobsListOffset, setClientJobsListOffset] = useState(0);
  const [isInitialLoading, setIsInitialLoading] = useState(false);
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const [clientJobsListHasMore, setClientJobsListHasMore] = useState(true);
  const [showLoader, setShowLoader] = useState(false);

  // Job Details Container states
  const [jobsSideContainerOpen, setJobsSideContainerOpen] = useState(false);
  const [selectedJobDetails, setSelectedJobDetails] = useState(null);
  const [jobDetailsActiveTab, setJobDetailsActiveTab] = useState("Job Details");
  const [isEditingJob, setIsEditingJob] = useState(false);
  const [originalJobData, setOriginalJobData] = useState(null);
  const [editedJobData, setEditedJobData] = useState(null);
  const [openJobDeleteDialog, setOpenJobDeleteDialog] = useState(false);
  const [assignedCount, setAssignedCount] = useState(0);
  const [isFetchingRecommendedCandidates, setIsFetchingRecommendedCandidates] =
    useState(false);
  const [jobDetailsValidation, setJobDetailsValidation] = useState(null);

  const groupedResults = useMemo(() => {
    const grouped = {};
    const validResults = (spreadsheetResults || []).filter(
      (result) => result.client_id,
    );
    validResults.forEach((result) => {
      if (!grouped[result.name]) {
        grouped[result.name] = {
          candidates: [],
          statusCounts: { created: 0, updated: 0, incomplete: 0 },
        };
      }
      const exists = grouped[result.name].candidates.some(
        (item) => item.client_id === result.client_id,
      );
      if (!exists) {
        grouped[result.name].candidates.push(result);
        const status = (result.client_creation_status || "").toLowerCase();
        if (status === "created") {
          grouped[result.name].statusCounts.created++;
        } else if (status === "updated") {
          grouped[result.name].statusCounts.updated++;
        } else if (status === "incomplete") {
          grouped[result.name].statusCounts.incomplete++;
        }
      }
    });
    return grouped;
  }, [spreadsheetResults]);

  const totalStatusCounts = useMemo(() => {
    let totalCreated = 0;
    let totalUpdated = 0;
    let totalIncomplete = 0;

    Object.values(groupedResults).forEach((fileData) => {
      totalCreated += fileData.statusCounts.created;
      totalUpdated += fileData.statusCounts.updated;
      totalIncomplete += fileData.statusCounts.incomplete;
    });
    failedSpreadsheets.forEach((file) => {
      if (file.isIncomplete) {
        totalIncomplete++;
      }
    });

    return { totalCreated, totalUpdated, totalIncomplete };
  }, [groupedResults, failedSpreadsheets]);

  const tableData = useMemo(() => {
    const data = [];
    Object.entries(groupedResults).forEach(([filename, fileData]) => {
      fileData.candidates.forEach((candidate, index) => {
        data.push({
          id: `${filename}-${candidate.client_id || index}`,
          filename,
          candidateData: candidate,
          client_id: candidate.client_id,
          client_name: candidate.client_name || "N/A",
          client_creation_status: candidate.client_creation_status,
          created_at: candidate.created_at,
        });
      });
    });
    return data;
  }, [groupedResults]);

  const sortedUploadedResumes = useMemo(() => {
    return [...(UploadedResumes || [])].sort((a, b) => {
      const isAFailed = failedSpreadsheets.some((f) => f.name === a.name);
      const isBFailed = failedSpreadsheets.some((f) => f.name === b.name);

      if (isAFailed && !isBFailed) return 1;
      if (!isAFailed && isBFailed) return -1;
      return 0;
    });
  }, [UploadedResumes, failedSpreadsheets]);

  // Formik for Client edit
  const formik = useFormik({
    initialValues: {
      email: "",
      clientName: "",
      companyType: "",
      contactPerson: "",
      contactDesignation: "",
      mobile: "",
      secondaryMobile: "",
      country: "",
      state: "",
      city: "",
      address1: "",
      address2: "",
      clientStatus: "",
      clientPriority: "",
      zipCode: "",
      remarks: "",
      clientType: "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email("Invalid email format.")
        .trim()
        .required("Email is required."),
      clientName: Yup.string()
        .trim()
        .required(
          isHiringTeamTenant
            ? "Hiring Team Name is required."
            : "Client Name is required.",
        ),
      contactPerson: Yup.string()
        .trim()
        .required("Contact Person is required."),
      contactDesignation: Yup.string()
        .trim()
        .required("Contact Designation is required."),
      mobile: Yup.string()
        .trim()
        .required("Mobile number is required.")
        .matches(/^\+?[0-9]+$/, "Invalid phone number format."),
      secondaryMobile: Yup.string()
        .matches(/^[0-9]+$/, "Only digits are allowed.")
        .notRequired(),
      country: Yup.string().trim(),
      state: Yup.string().trim(),
      city: Yup.string().trim(),
      address1: Yup.string().trim(),
      zipCode: Yup.string()
        .trim()
        .matches(/^[0-9]+$/, "Only digits are allowed for Zipcode."),
      remarks: Yup.string().trim().required("Remarks is required."),
      clientPriority: Yup.string().trim().required("Priority is required."),
      clientStatus: Yup.string()
        .trim()
        .required(
          isHiringTeamTenant ? "Activity is required" : "Status is required.",
        ),
    }),
    validateOnChange: true,
    validateOnBlur: true,
    validateOnSubmit: true,
  });

  // Formik for Client Contact
  const contactFormik = useFormik({
    initialValues: {
      contactName: "",
      contactEmail: "",
      contactPhoneNumber: "",
      contactDesignation: "",
      contactLocation: "",
    },
    validationSchema: Yup.object({
      contactName: Yup.string()
        .trim()
        .required("Contact Person Name is required"),
      contactEmail: Yup.string()
        .email("Invalid email address")
        .trim()
        .required("Email is required"),
      contactPhoneNumber: Yup.string()
        .trim()
        .required("Phone number is required")
        .matches(/^(\+)?[0-9\s\-\(\)]+$/, "Invalid phone number"),
      contactDesignation: Yup.string()
        .trim()
        .required("Contact Designation is required"),
      contactLocation: Yup.string().trim().required("Location is required"),
    }),
    onSubmit: (values) => {
      if (isEditingContact) {
        handleUpdateClientContactDetails(values);
      } else {
        handleCreateClientContactDetails(values);
      }
    },
  });

  // Formik for Tracking edit
  const editFormik = useFormik({
    initialValues: {
      editRemarks: "",
      editClientStatus: "",
      editClientPriority: "",
      editContactId: "",
    },
    onSubmit: async (values, { resetForm }) => {
      const trimmedValues = handleCustomTrim(values);
      if (
        trimmedValues.editClientStatus &&
        trimmedValues.editClientPriority &&
        trimmedValues.editRemarks
      ) {
        try {
          const payload = {
            id: selectedClient.id,
            priority: trimmedValues.editClientPriority,
            status: trimmedValues.editClientStatus,
            remarks: trimmedValues.editRemarks,
          };
          const currentContactId =
            selectedContactId || trimmedValues.editContactId;
          if (currentContactId) {
            payload.ContactID = currentContactId;
          }

          await post(
            VYLABS_BASE_URL,
            CREATE_CLIENT_TRACKING,
            payload,
          );
          setTrackingRefreshKey((prev) => prev + 1);
          resetForm();
          Toast("success", "Tracking history added successfully");
        } catch (error) {
          console.error("Error adding tracking history:", error);
          Toast("error", "Failed to add tracking history");
        }
      }
    },
  });

  // Formik for Reminder
  const reminderFormik = useFormik({
    initialValues: {
      callbackAt: "",
      callbackTime: "",
      callbackOffset: "",
    },
    onSubmit: async (values, { resetForm }) => {
      try {
        let payload = {
          callbackReminderOffset: values?.callbackOffset,
          callbackReminderUserID: userDetails?.id,
          date: moment(values?.callbackAt).format("YYYY-MM-DD"),
          entityID: selectedClient?.id,
          entityType: "client",
          time: values?.callbackTime,
          timezone: userDetails?.timezone,
        };
        await post(VYLABS_BASE_URL, CALLBACK_REMAINDERS_CREATE, payload);
        Toast("success", "Remainder created successfully");
        fetchCallbackReminders();
        setShowReminderDialog(false);
        resetForm();
        setTrackingRefreshKey((prev) => prev + 1);
      } catch (error) {
        console.error("Error setting reminder:", error);
        const backendMessage =
          error?.response?.data?.message ||
          error?.response?.data ||
          "Failed to set reminder";
        Toast("error", backendMessage);
      }
    },
  });

  const editRemainderFormik = useFormik({
    initialValues: {
      callbackAt: "",
      callbackTime: "",
      callbackOffset: "",
    },
    onSubmit: async (values, { resetForm }) => {
      try {
        let payload = {
          callbackReminderOffset: values?.callbackOffset,
          callbackReminderUserID: userDetails?.id,
          date: moment(values?.callbackAt).format("YYYY-MM-DD"),
          entityID: selectedClient?.id,
          entityType: "client",
          time: values?.callbackTime,
          timezone: userDetails?.timezone,
        };
        await put(VYLABS_BASE_URL, CALLBACK_REMAINDERS_UPDATE, payload);
        Toast("success", "Remainder updated successfully");
        fetchCallbackReminders();
        setShowReminderDialog(false);
        resetForm();
        setTrackingRefreshKey((prev) => prev + 1);
      } catch (error) {
        console.error("Error setting reminder:", error);
        const backendMessage =
          error?.response?.data?.message ||
          error?.response?.data ||
          "Failed to set reminder";
        Toast("error", backendMessage);
      }
    },
  });

  // Formik for Job Edit
  const jobEditFormik = useFormik({
    initialValues: {
      title: "",
      client_id: "",
      yearsOfExperience: "",
      educationLevel: "",
      company: "",
      jobLocation: "",
      jobType: "",
      skills: [],
      jobDescription: "",
      jobRole: "",
      salary_min: "",
      salary_max: "",
      tags: [],
      languageProficiency: "",
      openings: "",
    },
    validationSchema: Yup.object({
      title: Yup.string().required("Job Title is required"),
      jobRole: Yup.string().required("Job Role is required"),
      jobType: Yup.string().required("Job Type is required"),
      jobLocation: Yup.string().required("Job Location is required"),
      yearsOfExperience: Yup.number()
        .required("Experience is required")
        .integer("Experience must be an integer")
        .max(99, "Please enter a two digit number")
        .typeError("Experience must be a number"),
      salary_min: Yup.number(),
      salary_max: Yup.number(),
      jobDescription: Yup.string().nullable(),
      skills: Yup.mixed()
        .test(
          "is-array-or-string",
          "Skills must be an array or string",
          function (value) {
            return Array.isArray(value) || typeof value === "string";
          },
        )
        .required("Skills are required"),
      tags: Yup.array().nullable(),
      openings: Yup.number()
        .required("Number of openings is required")
        .integer("Number of openings must be an integer")
        .min(1, "Number of openings must be at least 1")
        .typeError("Number of openings must be a number"),
    }),
  });

  const sideDialogformik = useFormik({
    initialValues: {
      linkedIn: false,
      atolla: false,
    },
  });

  const isEditReminderMode = Boolean(callbackRemainderRes?.callbackAt);

  const getClientDetails = async (clientId) => {
    try {
      const response = await get(
        VYLABS_BASE_URL,
        `${GET_CLIENT_DETAILS}/?id=${clientId}`,
      );
      setSelectedClient(response.client);
      setChangedClient(response.client);
      setViewClient(true);
    } catch (err) {
      console.error("Client Details error", err);
    }
  };

  const fetchClientDetails = useCallback(async () => {
    if (selectedClient?.id) {
      try {
        const response = await get(
          VYLABS_BASE_URL,
          `${GET_CLIENT_DETAILS}/?id=${selectedClient.id}`,
        );
        setSelectedClient(response.client);
        setChangedClient(response.client);
      } catch (err) {
        console.error("Error refreshing client details:", err);
      }
    }
  }, [selectedClient?.id]);

  useEffect(() => {
    const fetchUserDetails = async () => {
      if (!selectedClient?.user_id) {
        setClientCreatedUserName("N/A");
        return;
      }
      try {
        const response = await get(
          VYLABS_BASE_URL,
          `${GET_RECRUITER_BY_ID}?id=${selectedClient.user_id}`,
        );
        if (response?.user) {
          setClientCreatedUserName(
            `${response.user.first_name} ${response.user.last_name}`.trim(),
          );
        }
      } catch (error) {
        console.error("Error fetching user details:", error);
        setClientCreatedUserName("Unknown");
      }
    };

    if (viewClient && selectedClient?.user_id) {
      fetchUserDetails();
    } else if (!viewClient) {
      setClientCreatedUserName("Loading...");
    }
  }, [selectedClient?.user_id, viewClient]);

  useEffect(() => {
    if (selectedClient?.contacts && selectedClient.contacts.length > 0) {
      const options = selectedClient.contacts.map((contact) => ({
        value: contact.id,
        label: `${contact.name} (${contact.designation || "No designation"})${contact.email ? ` - ${contact.email}` : ""}`,
        contact: contact,
      }));
      setContactOptions(options);
    } else {
      setContactOptions([]);
    }
  }, [selectedClient?.contacts]);

  useEffect(() => {
    if (selectedClient) {
      const initialValues = {
        email: selectedClient?.email || "",
        clientName: selectedClient?.name || "",
        contactPerson: selectedClient?.contact_person || "",
        contactDesignation: selectedClient?.contact_designation || "",
        mobile: selectedClient?.phone || "",
        country: selectedClient?.country || "",
        state: selectedClient?.state || "",
        city: selectedClient?.city || "",
        address1: selectedClient?.address || "",
        address2: selectedClient?.address_2 || "",
        zipCode: selectedClient?.zip_code || "",
        remarks: selectedClient?.remarks || "",
        clientStatus: selectedClient?.status || "",
        clientPriority: selectedClient?.priority || "",
        clientType: selectedClient?.client_type || "",
      };
      formik.setValues(initialValues);
      formik.setTouched({});
    }
  }, [selectedClient]);

  useEffect(() => {
    if (activeTab === "Jobs") {
      setShowLoader(true);
      const timer = setTimeout(() => {
        setShowLoader(false);
      }, 700);
      return () => clearTimeout(timer);
    }
  }, [activeTab]);

  const handlePhoneInputChange = useCallback(
    (phone) => {
      const normalizedPhone = phone?.startsWith("+") ? phone : `+${phone}`;
      formik.setFieldValue("mobile", normalizedPhone);
      formik.setFieldTouched("mobile", true, false);
      formik.validateField("mobile");
    },
    [formik],
  );

  const handleContactPhoneInputChange = useCallback(
    (phone) => {
      const normalizedPhone = phone?.startsWith("+") ? phone : `+${phone}`;
      contactFormik.setFieldValue("contactPhoneNumber", normalizedPhone);
      contactFormik.setFieldTouched("contactPhoneNumber", true, false);
      contactFormik.validateField("contactPhoneNumber");
    },
    [contactFormik],
  );

  const handleOpenAddContactPopup = () => {
    setIsEditingContact(false);
    setSelectedContact(null);
    contactFormik.resetForm();
    setShowClientContactPopup(true);
  };

  const handleOpenEditContactPopup = (contact) => {
    setIsEditingContact(true);
    setSelectedContact(contact);
    contactFormik.setValues({
      contactName: contact.name || "",
      contactEmail: contact.email || "",
      contactPhoneNumber: contact.phone || "",
      contactDesignation: contact.designation || "",
      contactLocation: contact.location || "",
    });
    setShowEditContactPopup(true);
  };

  const handleOpenViewContactPopup = (contact) => {
    setIsViewingContact(true);
    setSelectedContact(contact);
    contactFormik.setValues({
      contactName: contact.name || "",
      contactEmail: contact.email || "",
      contactPhoneNumber: contact.phone || "",
      contactDesignation: contact.designation || "",
      contactLocation: contact.location || "",
    });
    setShowEditContactPopup(true);
  };

  const handleOpenDeleteContactPopup = (contact) => {
    setSelectedContact(contact);
    setShowDeleteContactPopup(true);
  };

  const handleCloseContactPopup = () => {
    setShowClientContactPopup(false);
    setShowEditContactPopup(false);
    contactFormik.resetForm();
    setSelectedContact(null);
    setIsEditingContact(false);
    setIsViewingContact(false);
  };

  const handleCreateClientContactDetails = async (values) => {
    try {
      const errors = await contactFormik.validateForm();
      if (Object.keys(errors).length > 0) {
        contactFormik.setTouched({
          contactName: true,
          contactEmail: true,
          contactPhoneNumber: true,
          contactDesignation: true,
          contactLocation: true,
        });
        Toast("error", "Please fill all required fields correctly");
        return;
      }

      await post(VYLABS_BASE_URL, CREATE_CLIENT_CONTACT, {
        email: values.contactEmail.trim(),
        client_id: selectedClient?.id,
        name: values.contactName.trim(),
        phone: values.contactPhoneNumber.startsWith("+")
          ? values.contactPhoneNumber
          : `+${values.contactPhoneNumber}`,
        designation: values.contactDesignation.trim(),
        location: values.contactLocation?.trim() || "",
      });
      Toast("success", "Contact added successfully");
      handleCloseContactPopup();
      if (selectedClient?.id) {
        await fetchClientDetails();
      }
    } catch (error) {
      console.error("Create Client Contact Details error", error);
      Toast(
        "error",
        error.response?.data?.message ||
          "Failed to add contact. Please try again.",
      );
    }
  };

  const handleUpdateClientContactDetails = async (values) => {
    try {
      const errors = await contactFormik.validateForm();
      if (Object.keys(errors).length > 0) {
        contactFormik.setTouched({
          contactName: true,
          contactEmail: true,
          contactPhoneNumber: true,
          contactDesignation: true,
          contactLocation: true,
        });
        Toast("error", "Please fill all required fields correctly");
        return;
      }

      await post(VYLABS_BASE_URL, UPDATE_CLIENT_CONTACT, {
        id: selectedContact?.id,
        email: values.contactEmail.trim(),
        name: values.contactName.trim(),
        phone: values.contactPhoneNumber.startsWith("+")
          ? values.contactPhoneNumber
          : `+${values.contactPhoneNumber}`,
        designation: values.contactDesignation.trim(),
        location: values.contactLocation?.trim(),
      });
      Toast("success", "Contact updated successfully");
      handleCloseContactPopup();
      if (selectedClient?.id) {
        await fetchClientDetails();
      }
    } catch (error) {
      console.error("Update Client Contact Details error", error);
      Toast(
        "error",
        error.response?.data?.message ||
          "Failed to update contact. Please try again.",
      );
    }
  };

  const handleDeleteClientContactDetails = async () => {
    if (!selectedContact?.id) {
      Toast("error", "No contact selected for deletion");
      return;
    }

    try {
      await deleteRequest(VYLABS_BASE_URL, DELETE_CLIENT_CONTACT, {
        id: selectedContact.id,
      });
      Toast("success", "Contact deleted successfully");
      setShowDeleteContactPopup(false);
      setSelectedContact(null);

      if (selectedClient?.id) {
        await fetchClientDetails();
      }
    } catch (error) {
      console.error("Delete Client Contact Details error", error);
      Toast(
        "error",
        error.response?.data?.message ||
          "Failed to delete contact. Please try again.",
      );
    }
  };

  const fetchCallbackReminders = async () => {
    try {
      const res = await get(
        VYLABS_BASE_URL,
        `${CALLBACK_REMAINDERS}?entityType=client&entityID=${selectedClient?.id}`,
      );
      if (res?.callbackReminder) {
        setCallbackRemainderRes(res.callbackReminder);
      }
    } catch (error) {
      console.error("error in fetchCallbackReminders", error);
    }
  };

  const handleOpenReminderDialog = () => {
    if (isEditReminderMode) {
      const callbackDateTime = new Date(callbackRemainderRes.callbackAt);
      editRemainderFormik.setValues({
        callbackAt: callbackDateTime,
        callbackTime: callbackDateTime,
        callbackOffset: callbackRemainderRes?.callbackReminderOffset || "",
      });
    } else {
      reminderFormik.resetForm();
    }
    setShowReminderDialog(true);
  };

  const handleCloseReminderDialog = () => {
    setShowReminderDialog(false);
    if (isEditReminderMode) {
      editRemainderFormik.resetForm();
    } else {
      reminderFormik.resetForm();
    }
  };

  const handleSetReminderSubmit = (e) => {
    if (e && e.preventDefault) e.preventDefault();
    if (isEditReminderMode) {
      editRemainderFormik.handleSubmit(e);
    } else {
      reminderFormik.handleSubmit(e);
    }
  };

  const handleDeleteCallbackRemainder = async () => {
    try {
      await deleteRequest(VYLABS_BASE_URL, CALLBACK_REMAINDERS_DELETE, {
        entityID: selectedClient?.id,
        entityType: "client",
      });
      Toast("success", "Remainder deleted successfully.");
      fetchCallbackReminders();
      handleCloseReminderDialog();
    } catch (error) {
      console.error("error in handleDeleteCallbackReminder", error);
      Toast("error", error?.response?.data);
    }
  };

  const fetchClientJobs = async (customOffset = clientJobsListOffset) => {
    if (!selectedClient?.id) return;
    try {
      if (customOffset === 0) {
        setIsInitialLoading(true);
      } else {
        setIsLoadingMore(true);
      }
      const response = await get(
        VYLABS_BASE_URL,
        `${GET_JOB_LIST_BY_CLIENT}?client_id=${selectedClient.id}&offset=${customOffset}&limit=30`,
      );
      const jobs = response?.jobs ?? [];
      const fetchedJobs = Array.isArray(jobs)
        ? jobs.filter((job) => job?.id)
        : [];

      setClientJobsList((prev) => {
        if (customOffset === 0) {
          return fetchedJobs;
        } else {
          const merged = new Map();
          (prev || []).forEach((job) => {
            if (job?.id) merged.set(job.id, job);
          });
          fetchedJobs.forEach((job) => {
            if (job?.id) merged.set(job.id, job);
          });
          return Array.from(merged.values());
        }
      });

      setClientJobsListHasMore(jobs.length === 30);
    } catch (err) {
      console.error("fetchClientJobs error:", err);
      setClientJobsList((prev) => prev || []);
    } finally {
      setIsInitialLoading(false);
      setIsLoadingMore(false);
    }
  };

  const jobsListLastElement = useCallback(
    (node) => {
      if (!clientJobsListHasMore) return;

      if (clientJobsListObserver.current)
        clientJobsListObserver.current.disconnect();

      clientJobsListObserver.current = new IntersectionObserver(
        (entries) => {
          if (
            entries[0].isIntersecting &&
            clientJobsListHasMore &&
            !isLoadingMore
          ) {
            setIsLoadingMore(true);
            setClientJobsListOffset((prev) => prev + 30);
          }
        },
        {
          root: null,
          rootMargin: "20px",
          threshold: 0.1,
        },
      );

      if (node) clientJobsListObserver.current.observe(node);
    },
    [clientJobsListHasMore, isLoadingMore],
  );

  useEffect(() => {
    return () => {
      if (clientJobsListObserver.current) {
        clientJobsListObserver.current.disconnect();
      }
    };
  }, []);

  const fetchRecommendedCandidates = useCallback(async (jobId) => {
    try {
      setIsFetchingRecommendedCandidates(true);
      const jobRes = await get(
        VYLABS_BASE_URL,
        `${GET_JOB_DETAILS_BY_ID}?id=${jobId}`,
      );
      const job = jobRes?.job;

      if (!job) {
        console.error("Failed to fetch job details for recommendations");
        candidatesCache.set(jobId, []);
        setIsFetchingRecommendedCandidates(false);
        return [];
      }
      let skillsArray = [];
      if (Array.isArray(job.skills)) {
        skillsArray = job.skills;
      } else if (typeof job.skills === "string") {
        skillsArray = job.skills
          .split(",")
          .map((skill) => skill.trim())
          .filter((skill) => skill !== "");
      }

      const payload = {
        limit: 20,
        job_role: job.job_role || "",
        description: job.description || "",
        location: job.location || "",
        skills: skillsArray,
        experience: job.years_experience ? Number(job.years_experience) : 0,
      };

      const res = await post(
        VYLABS_BASE_URL,
        SIMPLE_SEARCH_CANDIDATES,
        payload,
      );
      const candidates = res?.candidates || [];
      const detailedCandidates = await Promise.all(
        candidates.map(async (candidate) => {
          try {
            const detailRes = await get(
              VYLABS_BASE_URL,
              `${GET_CANDIDATE_BY_ID}?id=${candidate.id}`,
            );
            return detailRes?.candidate || candidate;
          } catch {
            return candidate;
          }
        }),
      );

      candidatesCache.set(jobId, detailedCandidates);
      setIsFetchingRecommendedCandidates(false);
      return detailedCandidates;
    } catch (err) {
      console.error("Error fetching recommended candidates:", err);
      setIsFetchingRecommendedCandidates(false);
      candidatesCache.set(jobId, []);
      return [];
    }
  }, []);

  const handleOpenJobDetailsContainer = async (job, index, tab) => {
    if (!job) return;
    setJobsSideContainerOpen(true);
    setJobDetailsActiveTab(tab);
    try {
      const jobRes = await get(
        VYLABS_BASE_URL,
        `${GET_JOB_DETAILS_BY_ID}?id=${job.id}`,
      );
      let detailedJob = jobRes?.job || job;
      if (detailedJob?.client_id && !detailedJob?.client?.contact_person) {
        try {
          const clientRes = await get(
            VYLABS_BASE_URL,
            `${GET_CLIENT_DETAILS}/?id=${detailedJob.client_id}`,
          );
          if (clientRes?.client) {
            detailedJob.client = clientRes.client;
          }
        } catch (err) {
          console.warn("Could not fetch client details:", err);
        }
      }
      setSelectedJobDetails({ ...detailedJob, index });
      await fetchRecommendedCandidates(job.id);
    } catch (err) {
      console.error("Error fetching job details:", err);
      setSelectedJobDetails({ ...job, index });
      await fetchRecommendedCandidates(job.id);
    }
  };

  const handleCloseJobDetailsContainer = () => {
    setJobsSideContainerOpen(false);
    setSelectedJobDetails(null);
    setJobDetailsActiveTab("Job Details");
    if (selectedJobDetails?.id) {
      candidatesCache.delete(selectedJobDetails.id);
    }
    resetJobEdit();
  };

  const handleEditJob = () => {
    setOriginalJobData({ ...selectedJobDetails });
    setEditedJobData({ ...selectedJobDetails });
    setIsEditingJob(true);
  };

  const resetJobEdit = () => {
    if (originalJobData) {
      setSelectedJobDetails(originalJobData);
      jobEditFormik.setValues({
        title: originalJobData.title || "",
        yearsOfExperience: originalJobData.years_experience?.toString() || "",
        jobLocation: originalJobData.location || "",
        jobType: originalJobData.job_type || "",
        skills: Array.isArray(originalJobData.skills)
          ? originalJobData.skills
          : typeof originalJobData.skills === "string"
            ? [originalJobData.skills]
            : [],
        jobDescription: originalJobData.description || "",
        jobRole: originalJobData.job_role || "",
        salary_min: originalJobData.salary_min?.toString() || "",
        salary_max: originalJobData.salary_max?.toString() || "",
        tags: originalJobData.tags || [],
        openings: originalJobData.openings?.toString() || "",
      });
    }
    setIsEditingJob(false);
    setOriginalJobData(null);
    setEditedJobData(null);
  };

  const handleOpenDeleteJobDialog = () => {
    setOpenJobDeleteDialog(true);
  };

  const handleDeleteJob = async () => {
    try {
      await deleteRequest(
        VYLABS_BASE_URL,
        `${DELETE_JOB}?id=${selectedJobDetails.id}`,
      );
      Toast("success", "Job deleted successfully");
      setClientJobsList((prevJobs) =>
        prevJobs.filter((job) => job.id !== selectedJobDetails.id),
      );
      handleCloseJobDetailsContainer();
    } catch (error) {
      console.error("Error deleting job:", error);
    } finally {
      setOpenJobDeleteDialog(false);
    }
  };

  const handleJobChange = (data) => {
    if (data.validateForm) {
      setJobDetailsValidation(() => data.validateForm);
    } else {
      const updatedValues = {
        ...jobEditFormik.values,
        title: data.title || jobEditFormik.values.title,
        jobRole: data.job_role || jobEditFormik.values.jobRole,
        jobDescription: data.description || jobEditFormik.values.jobDescription,
        skills: data.skills || jobEditFormik.values.skills,
        tags: data.tags || jobEditFormik.values.tags,
        openings: data.openings || jobEditFormik.values.openings,
      };
      jobEditFormik.setValues(updatedValues);
      setEditedJobData((prev) => ({
        ...prev,
        ...data,
        years_experience: jobEditFormik.values.yearsOfExperience,
        location: jobEditFormik.values.jobLocation,
        salary_min: jobEditFormik.values.salary_min,
        salary_max: jobEditFormik.values.salary_max,
        job_type: jobEditFormik.values.jobType,
        openings: jobEditFormik.values.openings,
      }));
    }
  };

  const saveJobChanges = async () => {
    if (jobDetailsValidation) {
      const jobDetailsResult = await jobDetailsValidation();
      if (!jobDetailsResult.isValid) {
        Toast("error", "Please fill all required fields correctly");
        return;
      }
    }

    await jobEditFormik.validateForm();
    if (!jobEditFormik.isValid) {
      jobEditFormik.setTouched({
        title: true,
        jobRole: true,
        jobType: true,
        jobLocation: true,
        yearsOfExperience: true,
        salary_min: true,
        salary_max: true,
        skills: true,
        openings: true,
      });
      Toast("error", "Please fill all required fields correctly");
      return;
    }

    try {
      const jobDetailsResult = await jobDetailsValidation();
      const mainFormValues = jobEditFormik.values;

      const combinedValues = {
        ...mainFormValues,
        title: mainFormValues.title || jobDetailsResult.values.title,
        jobRole: mainFormValues.jobRole || jobDetailsResult.values.job_role,
        jobDescription:
          jobDetailsResult.values.description ||
          mainFormValues.jobDescription ||
          "",
        skills: mainFormValues.skills || jobDetailsResult.values.skills,
        tags: mainFormValues.tags || jobDetailsResult.values.tags,
        openings: mainFormValues.openings || jobDetailsResult.values.openings,
      };

      const skills = Array.isArray(combinedValues.skills)
        ? combinedValues.skills.join(", ")
        : combinedValues.skills || "";

      const tags = Array.isArray(combinedValues.tags)
        ? combinedValues.tags.join(", ")
        : combinedValues.tags || "";

      const jobData = {
        jobID: selectedJobDetails.id,
        jobTitle: combinedValues.title,
        jobRole: combinedValues.jobRole,
        jobType: combinedValues.jobType,
        jobYearsExperience: Number(combinedValues.yearsOfExperience || 0),
        jobSalaryMin: Number(combinedValues.salary_min || 0),
        jobSalaryMax: Number(combinedValues.salary_max || 0),
        jobLocation: combinedValues.jobLocation,
        jobDescription: combinedValues.jobDescription,
        jobSkills: skills,
        jobTags: tags,
        jobOpenings: Number(combinedValues.openings || 0),
      };

      await put(VYLABS_BASE_URL, UPDATE_JOB, jobData);

      const updatedJob = {
        ...selectedJobDetails,
        id: selectedJobDetails.id,
        title: combinedValues.title,
        job_role: combinedValues.jobRole,
        job_type: combinedValues.jobType,
        years_experience: combinedValues.yearsOfExperience,
        salary_min: combinedValues.salary_min,
        salary_max: combinedValues.salary_max,
        location: combinedValues.jobLocation,
        description: combinedValues.jobDescription,
        skills: combinedValues.skills,
        tags: combinedValues.tags,
        openings: combinedValues.openings,
      };

      setSelectedJobDetails(updatedJob);
      setIsEditingJob(false);
      Toast("success", "Job updated successfully");

      setClientJobsList((prevJobs) =>
        prevJobs.map((job) => (job.id === updatedJob.id ? updatedJob : job)),
      );
      handleCloseJobDetailsContainer();
    } catch (error) {
      console.error("Error updating job:", error);
      Toast(
        "error",
        "Failed to update job: " +
          (error.response?.data?.message || error.message),
      );
    }
  };

  useEffect(() => {
    if (selectedJobDetails && !isEditingJob) {
      const initialValues = {
        title: selectedJobDetails.title || "",
        yearsOfExperience:
          selectedJobDetails.years_experience?.toString() || "",
        jobLocation: selectedJobDetails.location || "",
        jobType: selectedJobDetails.job_type || "",
        skills: Array.isArray(selectedJobDetails.skills)
          ? selectedJobDetails.skills
          : typeof selectedJobDetails.skills === "string"
            ? [selectedJobDetails.skills]
            : [],
        jobDescription: selectedJobDetails.description || "",
        jobRole: selectedJobDetails.job_role || "",
        salary_min: selectedJobDetails.salary_min?.toString() || "",
        salary_max: selectedJobDetails.salary_max?.toString() || "",
        tags: selectedJobDetails.tags || [],
        openings: selectedJobDetails.openings?.toString() || "",
      };
      jobEditFormik.setValues(initialValues);
    }
  }, [selectedJobDetails, isEditingJob]);

  useEffect(() => {
    if (!selectedClient) return;
    if (activeTab === "Jobs") {
      setClientJobsList([]);
      setClientJobsListOffset(0);
      setClientJobsListHasMore(true);
    }
  }, [activeTab, selectedClient]);

  useEffect(() => {
    if (activeTab !== "Jobs" || !selectedClient) return;
    fetchClientJobs(clientJobsListOffset);
  }, [clientJobsListOffset, activeTab, selectedClient]);

  const handleEditClient = async () => {
    setIsEditingClient(true);
  };

  const handleCancelEditClient = () => {
    setIsEditingClient(false);
    if (selectedClient) {
      const initialValues = {
        email: selectedClient?.email || "",
        clientName: selectedClient?.name || "",
        contactPerson: selectedClient?.contact_person || "",
        contactDesignation: selectedClient?.contact_designation || "",
        mobile: selectedClient?.phone || "",
        country: selectedClient?.country || "",
        state: selectedClient?.state || "",
        city: selectedClient?.city || "",
        address1: selectedClient?.address || "",
        address2: selectedClient?.address_2 || "",
        zipCode: selectedClient?.zip_code || "",
        remarks: selectedClient?.remarks || "",
        clientStatus: selectedClient?.status || "",
        clientPriority: selectedClient?.priority || "",
        clientType: selectedClient?.client_type || "",
      };
      formik.setValues(initialValues);
      formik.setTouched({});
      formik.setErrors({});
    }
  };

  const handleCloseClientDetails = () => {
    setViewClient(false);
    setSelectedClient(null);
    setActiveTab("Jobs");
    setIsEditingClient(false);
    formik.resetForm();
    setSelectedContactId("");
    editFormik.resetForm();
  };

  const handleOpenClientDeleteDialog = () => {
    setIsClientDeleteDialogOpen(true);
  };

  const handleDeleteClient = async () => {
    try {
      await deleteRequest(VYLABS_BASE_URL, DELETE_CLIENT_DETAILS, {
        id: selectedClient.id,
      });
      Toast("success", `${tenantLabel} deleted successfully`);
      setIsClientDeleteDialogOpen(false);
      setViewClient(false);
      if (setSpreadsheetResults) {
        setSpreadsheetResults((prev) =>
          prev.filter((item) => item.client_id !== selectedClient.id),
        );
      }
      setSelectedClient(null);
      setIsEditingClient(false);
    } catch (error) {
      console.error("Error deleting client:", error);
    }
  };

  const saveClientChanges = async () => {
    if (!selectedClient || !changedClient) {
      Toast("error", "No client selected or initial data missing");
      return;
    }

    try {
      const errors = await formik.validateForm();
      if (Object.keys(errors).length > 0) {
        Object.keys(errors).forEach((key) => {
          formik.setFieldTouched(key, true, false);
        });
        Toast("error", "Please fill all required fields correctly");
        return;
      }

      const payloadValues = {
        name: formik.values.clientName.trim(),
        contactPerson: formik.values.contactPerson.trim(),
        contactDesignation: formik.values.contactDesignation.trim(),
        email: formik.values.email.trim(),
        phone: formik.values.mobile
          ? formik.values.mobile.startsWith("+")
            ? formik.values.mobile
            : `+${formik.values.mobile}`
          : "",
        country: formik.values.country.trim(),
        state: formik.values.state.trim(),
        city: formik.values.city.trim(),
        address: formik.values.address1.trim(),
        address_2: (formik.values.address2 || "").trim(),
        zipCode: formik.values.zipCode.trim(),
        remarks: (formik.values.remarks || "").trim(),
        clientType: (formik.values.clientType || "").trim(),
      };

      const changes = {};
      for (const key in payloadValues) {
        const currentValue = payloadValues[key];
        const originalValue = changedClient[key];

        const normalizedCurrentValue =
          currentValue === null || currentValue === undefined
            ? ""
            : String(currentValue).trim();
        const normalizedOriginalValue =
          originalValue === null || originalValue === undefined
            ? ""
            : String(originalValue).trim();

        if (normalizedCurrentValue !== normalizedOriginalValue) {
          if (
            (key === "address2" || key === "remarks") &&
            (originalValue === null || originalValue === undefined) &&
            normalizedCurrentValue === ""
          ) {
            continue;
          }
          changes[key] = currentValue;
        }
      }

      if (Object.keys(changes).length === 0) {
        Toast("info", "No changes detected");
        setIsEditingClient(false);
        return;
      }

      const payload = {
        id: selectedClient.id,
        ...changes,
      };

      await post(VYLABS_BASE_URL, UPDATE_CLIENT_INFO, payload);
      Toast("success", `${tenantLabel} updated successfully`);

      const updatedClientState = { ...changedClient };
      for (const key in changes) {
        updatedClientState[key] = changes[key];
      }

      setSelectedClient(updatedClientState);
      setChangedClient(updatedClientState);
      setViewClient(false);
      setIsEditingClient(false);

      if (setSpreadsheetResults && changes.name) {
        setSpreadsheetResults((prev) =>
          prev.map((item) =>
            item.client_id === selectedClient.id
              ? { ...item, client_name: changes.name }
              : item,
          ),
        );
      }
    } catch (error) {
      console.error("Error updating client:", error);
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        `Failed to update ${tenantLabelLower}. Please try again.`;
      Toast("error", errorMessage);
    }
  };

  const renderContent = () => {
    switch (activeTab) {
      case "Jobs":
        return (
          <ClientJobs
            clientId={selectedClient?.id}
            onOpenJobDetails={(job, index, tab, isEditing = false) => {
              setJobDetailsActiveTab(tab);
              handleOpenJobDetailsContainer(job, index, tab);
              if (isEditing) {
                setIsEditingJob(true);
              }
            }}
            jobsListLastElement={jobsListLastElement}
            setClientJobsList={setClientJobsList}
            clientJobsList={clientJobsList}
            isInitialLoading={isInitialLoading}
            setIsInitialLoading={setIsInitialLoading}
            isLoadingMore={isLoadingMore}
            setIsLoadingMore={setIsLoadingMore}
            clientJobsListHasMore={clientJobsListHasMore}
            setClientJobsListHasMore={setClientJobsListHasMore}
            showLoader={showLoader}
            setShowLoader={setShowLoader}
          />
        );

      case "Tracking":
        return (
          <ClientTracking
            clientId={selectedClient?.id}
            clientPriority={clientPriority}
            clientStatus={activeClientStatusOptions}
            selectedClient={selectedClient}
            contactOptions={contactOptions}
            setSelectedContactId={setSelectedContactId}
            editFormik={editFormik}
            handleTriggerClear={handleTriggerClear}
            clearTriggered={clearTriggered}
            setClearTriggered={setClearTriggered}
            trackingRefreshKey={trackingRefreshKey}
            isDarkMode={isDarkMode}
            reminderFormik={reminderFormik}
            editRemainderFormik={editRemainderFormik}
            showReminderDialog={showReminderDialog}
            onOpenReminderDialog={handleOpenReminderDialog}
            onCloseReminderDialog={handleCloseReminderDialog}
            onSubmitReminder={handleSetReminderSubmit}
            fetchCallbackReminders={fetchCallbackReminders}
            callbackRemainderRes={callbackRemainderRes}
            handleDeleteCallbackRemainder={handleDeleteCallbackRemainder}
            isHiringTeamTenant={isHiringTeamTenant}
          />
        );

      case "Additional Contacts":
        return (
          <ClientAdditionalContacts
            contacts={selectedClient?.contacts || []}
            onAddContact={handleOpenAddContactPopup}
            onViewContact={handleOpenViewContactPopup}
            onEditContact={handleOpenEditContactPopup}
            onDeleteContact={handleOpenDeleteContactPopup}
            isDarkMode={isDarkMode}
            clientId={selectedClient?.id}
          />
        );

      case "Documents":
        return <ClientDocuments clientId={selectedClient?.id} />;

      default:
        return null;
    }
  };

  const columns = [
    {
      name: "#",
      selector: (row, index) => <span>{index + 1}</span>,
      width: "80px",
    },
    {
      name: isHiringTeamTenant ? "Hiring Team Name" : "Client Name",
      selector: (row) => (
        <CustomTooltip title={row.client_name} arrow>
          <span>{row.client_name}</span>
        </CustomTooltip>
      ),
      width: "250px",
    },
    {
      name: "Spreadsheet File",
      selector: (row) => (
        <CustomTooltip title={row.filename} arrow>
          <span className="parsing-file-name-container">
            <FileIcon fileName={row.filename} />
            {row.filename}
          </span>
        </CustomTooltip>
      ),
      width: "250px",
    },
    {
      name: "Status",
      selector: (row) => {
        const status = (row.client_creation_status || "N/A").toLowerCase();
        return (
          <span
            style={{
              color:
                status === "created"
                  ? "green"
                  : status === "updated"
                    ? "#ffc100"
                    : status === "incomplete"
                      ? "#FF6B6B"
                      : "gray",
              fontSize: "14px",
              fontWeight: "bold",
              textAlign: "center",
            }}
          >
            {status.charAt(0).toUpperCase() + status.slice(1)}
          </span>
        );
      },
      width: "120px",
    },
    {
      name: "Actions",
      cell: (row) => {
        if (!row.client_id) return null;

        return (
          <div
            style={{
              display: "flex",
              justifyContent: "flex-start",
              width: "100%",
            }}
            className="action-icons"
          >
            <CustomTooltip title={`View ${tenantLabel}`} arrow>
              <img
                src={viewCandidateIcon}
                alt={`View ${tenantLabel}`}
                className="parser-table-action-icons"
                onClick={() => {
                  getClientDetails(row.client_id);
                }}
                style={{ cursor: "pointer" }}
              />
            </CustomTooltip>
          </div>
        );
      },
      width: "100px",
    },
  ];

  const handleClearResults = () => {
    if (window.socketRef?.current) {
      window.socketRef.current.close(1000, "User returned to upload page");
      window.socketRef.current = null;
    }
    if (window.countdownIntervalRef?.current) {
      clearInterval(window.countdownIntervalRef.current);
      window.countdownIntervalRef.current = null;
    }
    setSpreadsheetResults([]);
    setUploadedResumes([]);
    setFailedSpreadsheets([]);
    if (resetSpreadsheetState) {
      resetSpreadsheetState();
    }
  };

  return (
    <>
      <JobStatusUpdatePopup />
      <div className="header-and-resume-button-container">
        <div className="upload-parser-resume-header">
          {showHeader && (
            <div className="header-parser-main-container">
              <div className="header-icon-title-container">
                <h2 className="upload-resume-header">
                  Spreadsheet Import Results
                </h2>
              </div>
              <div className="right-side-button-container">
                <Button
                  className="import-action-buttons"
                  label="Back to Upload"
                  iconSrc={uploadIcon}
                  event={handleClearResults}
                />
              </div>
            </div>
          )}
        </div>
      </div>

      <div
        className="spreadsheet-summary-container"
        style={{
          background: isDarkMode ? "rgba(30, 30, 40, 0.7)" : "white",
          borderRadius: "12px",
          padding: "20px",
          margin: "20px",
          border: isDarkMode
            ? "1px solid rgba(255, 255, 255, 0.1)"
            : "1px solid rgba(0, 0, 0, 0.05)",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "20px",
          }}
        >
          <div>
            <h3
              style={{
                color: isDarkMode ? "#fff" : "#6860EE",
                margin: 0,
                fontSize: "18px",
                fontWeight: "600",
              }}
            >
              Import Summary
            </h3>
            <p
              style={{
                color: isDarkMode ? "rgba(255,255,255,0.6)" : "rgba(0,0,0,0.5)",
                fontSize: "14px",
                margin: "4px 0 0 0",
              }}
            >
              {(UploadedResumes || []).length} files processed
            </p>
          </div>

          <div style={{ display: "flex", gap: "12px" }}>
            <div
              style={{
                padding: "12px 16px",
                background: isDarkMode
                  ? "rgba(104, 96, 238, 0.15)"
                  : "rgba(104, 96, 238, 0.08)",
                borderRadius: "10px",
                border: isDarkMode
                  ? "1px solid rgba(104, 96, 238, 0.3)"
                  : "1px solid rgba(104, 96, 238, 0.2)",
                minWidth: "120px",
                textAlign: "center",
              }}
            >
              <div
                style={{
                  fontSize: "12px",
                  fontWeight: "500",
                  color: isDarkMode ? "rgba(255,255,255,0.7)" : "#666",
                  marginBottom: "4px",
                }}
              >
                Total Files
              </div>
              <div
                style={{
                  fontSize: "24px",
                  fontWeight: "700",
                  color: isDarkMode ? "#fff" : "#6860EE",
                  lineHeight: "1",
                }}
              >
                {(UploadedResumes || []).length}
              </div>
              <div
                style={{
                  fontSize: "11px",
                  color: isDarkMode ? "rgba(255,255,255,0.7)" : "#666",
                  marginTop: "4px",
                }}
              >
                Uploaded
              </div>
            </div>
            <div
              style={{
                padding: "12px 16px",
                background: isDarkMode
                  ? "rgba(76, 175, 80, 0.15)"
                  : "rgba(76, 175, 80, 0.08)",
                borderRadius: "10px",
                border: isDarkMode
                  ? "1px solid rgba(76, 175, 80, 0.3)"
                  : "1px solid rgba(76, 175, 80, 0.2)",
                minWidth: "120px",
                textAlign: "center",
              }}
            >
              <div
                style={{
                  fontSize: "12px",
                  fontWeight: "500",
                  color: isDarkMode ? "rgba(255,255,255,0.7)" : "#666",
                  marginBottom: "4px",
                }}
              >
                Created
              </div>
              <div
                style={{
                  fontSize: "24px",
                  fontWeight: "700",
                  color: isDarkMode ? "#4CAF50" : "#2E7D32",
                  lineHeight: "1",
                }}
              >
                {totalStatusCounts.totalCreated}
              </div>
              <div
                style={{
                  fontSize: "11px",
                  color: isDarkMode ? "rgba(76, 175, 80, 0.8)" : "#4CAF50",
                  marginTop: "4px",
                }}
              >
                {isHiringTeamTenant ? "New hiring teams" : "New clients"}
              </div>
            </div>
            <div
              style={{
                padding: "12px 16px",
                background: isDarkMode
                  ? "rgba(255, 152, 0, 0.15)"
                  : "rgba(255, 152, 0, 0.08)",
                borderRadius: "10px",
                border: isDarkMode
                  ? "1px solid rgba(255, 152, 0, 0.3)"
                  : "1px solid rgba(255, 152, 0, 0.2)",
                minWidth: "120px",
                textAlign: "center",
              }}
            >
              <div
                style={{
                  fontSize: "12px",
                  fontWeight: "500",
                  color: isDarkMode ? "rgba(255,255,255,0.7)" : "#666",
                  marginBottom: "4px",
                }}
              >
                Updated
              </div>
              <div
                style={{
                  fontSize: "24px",
                  fontWeight: "700",
                  color: isDarkMode ? "#FF9800" : "#EF6C00",
                  lineHeight: "1",
                }}
              >
                {totalStatusCounts.totalUpdated}
              </div>
              <div
                style={{
                  fontSize: "11px",
                  color: isDarkMode ? "rgba(255, 152, 0, 0.8)" : "#FF9800",
                  marginTop: "4px",
                }}
              >
                {isHiringTeamTenant
                  ? "Existing hiring teams"
                  : "Existing clients"}
              </div>
            </div>
            <div
              style={{
                padding: "12px 16px",
                background: isDarkMode
                  ? "rgba(255, 107, 107, 0.15)"
                  : "rgba(255, 107, 107, 0.08)",
                borderRadius: "10px",
                border: isDarkMode
                  ? "1px solid rgba(255, 107, 107, 0.3)"
                  : "1px solid rgba(255, 107, 107, 0.2)",
                minWidth: "120px",
                textAlign: "center",
              }}
            >
              <div
                style={{
                  fontSize: "12px",
                  fontWeight: "500",
                  color: isDarkMode ? "rgba(255,255,255,0.7)" : "#666",
                  marginBottom: "4px",
                }}
              >
                Incomplete
              </div>
              <div
                style={{
                  fontSize: "24px",
                  fontWeight: "700",
                  color: isDarkMode ? "#FF6B6B" : "#D32F2F",
                  lineHeight: "1",
                }}
              >
                {totalStatusCounts.totalIncomplete}
              </div>
              <div
                style={{
                  fontSize: "11px",
                  color: isDarkMode ? "rgba(255, 107, 107, 0.8)" : "#FF6B6B",
                  marginTop: "4px",
                }}
              >
                Partial processing
              </div>
            </div>
          </div>
        </div>
        <div style={{ maxHeight: "130px", overflowY: "scroll" }}>
          {sortedUploadedResumes.map((file) => {
            const filename = file.name;
            const fileData = groupedResults[filename];
            const failedFile = failedSpreadsheets.find(
              (f) => f.name === filename,
            );

            if (fileData) {
              const {
                created,
                updated,
                incomplete: baseIncomplete,
              } = fileData.statusCounts;
              const failedFileForThis = failedSpreadsheets.find(
                (f) => f.name === filename,
              );
              const incomplete =
                baseIncomplete + (failedFileForThis?.isIncomplete ? 1 : 0);
              return (
                <div
                  key={filename}
                  style={{
                    padding: "12px",
                    marginBottom: "8px",
                    background: isDarkMode
                      ? "rgba(255, 255, 255, 0.05)"
                      : "rgba(0, 0, 0, 0.02)",
                    borderRadius: "8px",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >
                    <FileIcon fileName={filename} />
                    <strong
                      style={{
                        color: isDarkMode ? "#fff" : "#333",
                        fontSize: "14px",
                      }}
                    >
                      {filename}
                    </strong>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                    }}
                  >
                    {created > 0 && (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "4px",
                          padding: "4px 8px",
                          background: isDarkMode
                            ? "rgba(76, 175, 80, 0.15)"
                            : "rgba(76, 175, 80, 0.1)",
                          borderRadius: "6px",
                          border: isDarkMode
                            ? "1px solid rgba(76, 175, 80, 0.3)"
                            : "1px solid rgba(76, 175, 80, 0.2)",
                        }}
                      >
                        <div
                          style={{
                            width: "6px",
                            height: "6px",
                            borderRadius: "50%",
                            background: "#4CAF50",
                          }}
                        />
                        <span
                          style={{
                            fontSize: "12px",
                            fontWeight: "500",
                            color: isDarkMode ? "#4CAF50" : "#2E7D32",
                          }}
                        >
                          Created: {created}
                        </span>
                      </div>
                    )}
                    {updated > 0 && (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "4px",
                          padding: "4px 8px",
                          background: isDarkMode
                            ? "rgba(255, 152, 0, 0.15)"
                            : "rgba(255, 152, 0, 0.1)",
                          borderRadius: "6px",
                          border: isDarkMode
                            ? "1px solid rgba(255, 152, 0, 0.3)"
                            : "1px solid rgba(255, 152, 0, 0.2)",
                        }}
                      >
                        <div
                          style={{
                            width: "6px",
                            height: "6px",
                            borderRadius: "50%",
                            background: "#FF9800",
                          }}
                        />
                        <span
                          style={{
                            fontSize: "12px",
                            fontWeight: "500",
                            color: isDarkMode ? "#FF9800" : "#EF6C00",
                          }}
                        >
                          Updated: {updated}
                        </span>
                      </div>
                    )}
                    {incomplete > 0 && (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "4px",
                          padding: "4px 8px",
                          background: isDarkMode
                            ? "rgba(255, 107, 107, 0.15)"
                            : "rgba(255, 107, 107, 0.1)",
                          borderRadius: "6px",
                          border: isDarkMode
                            ? "1px solid rgba(255, 107, 107, 0.3)"
                            : "1px solid rgba(255, 107, 107, 0.2)",
                        }}
                      >
                        <div
                          style={{
                            width: "6px",
                            height: "6px",
                            borderRadius: "50%",
                            background: "#FF6B6B",
                          }}
                        />
                        <span
                          style={{
                            fontSize: "12px",
                            fontWeight: "500",
                            color: isDarkMode ? "#FF6B6B" : "#D32F2F",
                          }}
                        >
                          Incomplete: {incomplete}
                        </span>
                      </div>
                    )}
                  </div>
                </div>
              );
            } else if (failedFile) {
              return (
                <div
                  key={failedFile.id || failedFile.name}
                  style={{
                    padding: "12px",
                    marginBottom: "8px",
                    background: isDarkMode
                      ? `rgba(${failedFile.isIncomplete ? "255, 152, 0" : "244, 67, 54"}, 0.05)`
                      : `rgba(${failedFile.isIncomplete ? "255, 152, 0" : "244, 67, 54"}, 0.03)`,
                    borderRadius: "8px",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >
                    <FileIcon fileName={failedFile.name} />
                    <div>
                      <strong
                        style={{
                          color: isDarkMode ? "#fff" : "#333",
                          fontSize: "14px",
                        }}
                      >
                        {failedFile.name}
                      </strong>
                      <div
                        style={{
                          fontSize: "12px",
                          color: isDarkMode
                            ? failedFile.isIncomplete
                              ? "rgba(255, 152, 0, 0.9)"
                              : "rgba(244, 67, 54, 0.9)"
                            : failedFile.isIncomplete
                              ? "#EF6C00"
                              : "#D32F2F",
                          marginTop: "2px",
                          fontWeight: "500",
                        }}
                      >
                        <strong>Error:</strong> {failedFile.error}
                      </div>
                      {failedFile.isIncomplete && (
                        <div
                          style={{
                            fontSize: "11px",
                            color: isDarkMode
                              ? "rgba(255, 152, 0, 0.9)"
                              : "#EF6C00",
                            marginTop: "2px",
                            fontWeight: "500",
                          }}
                        >
                          ⚠️ Partial data was extracted but processing was
                          incomplete
                        </div>
                      )}
                    </div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "4px",
                      padding: "4px 8px",
                      background: isDarkMode
                        ? `rgba(${failedFile.isIncomplete ? "255, 152, 0" : "244, 67, 54"}, 0.15)`
                        : `rgba(${failedFile.isIncomplete ? "255, 152, 0" : "244, 67, 54"}, 0.1)`,
                      borderRadius: "6px",
                      border: isDarkMode
                        ? `1px solid rgba(${failedFile.isIncomplete ? "255, 152, 0" : "244, 67, 54"}, 0.3)`
                        : `1px solid rgba(${failedFile.isIncomplete ? "255, 152, 0" : "244, 67, 54"}, 0.2)`,
                    }}
                  >
                    <div
                      style={{
                        width: "6px",
                        height: "6px",
                        borderRadius: "50%",
                        background: failedFile.isIncomplete
                          ? "#FF9800"
                          : "#F44336",
                      }}
                    />
                    <span
                      style={{
                        fontSize: "12px",
                        fontWeight: "500",
                        color: isDarkMode
                          ? failedFile.isIncomplete
                            ? "#FF9800"
                            : "#F44336"
                          : failedFile.isIncomplete
                            ? "#EF6C00"
                            : "#D32F2F",
                      }}
                    >
                      {failedFile.isIncomplete ? "Incomplete" : "Failed"}
                    </span>
                  </div>
                </div>
              );
            } else {
              return (
                <div
                  key={filename}
                  style={{
                    padding: "12px",
                    marginBottom: "8px",
                    background: isDarkMode
                      ? "rgba(255, 255, 255, 0.05)"
                      : "rgba(0, 0, 0, 0.02)",
                    borderRadius: "8px",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >
                    <FileIcon fileName={filename} />
                    <strong
                      style={{
                        color: isDarkMode ? "#fff" : "#333",
                        fontSize: "14px",
                      }}
                    >
                      {filename}
                    </strong>
                  </div>
                  <div className="parsed-status-container">
                    <DotLoader size={1} borderWidth={5} duration={1.5} />
                    <span>Processing</span>
                  </div>
                </div>
              );
            }
          })}
        </div>
      </div>

      <div className="main-resume-container">
        <div className="table-container">
          <Table
            columns={columns}
            data={tableData}
            pagination
            highlightOnHover
            fixedHeader
            fixedHeaderScrollHeight="500px"
            dataNotFoundMessage="No spreadsheet import results yet..!"
            clearSelectedRows={false}
            backgroundColor="var(--body__background)"
            color="var(--header__color)"
          />
        </div>
      </div>

      <SidePopup
        isOpen={viewClient}
        onClose={() => {
          handleCloseClientDetails();
        }}
        title={
          <CustomTooltip title={selectedClient?.name} arrow>
            <span>{applyEllipsis(selectedClient?.name, 30)}</span>
          </CustomTooltip>
        }
        sidePopupStyle={{
          width: "80%",
        }}
        headerRightContent={
          <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
            {selectedClient && (
              <div className="client-create-update-details">
                <div className="company-dates">
                  <span>
                    Created at :{" "}
                    {formatDate(selectedClient?.created_at, false, true) ||
                      "N/A"}
                  </span>
                </div>
                {userDetails?.tenant_id ===
                "8d01a95f87c7465a9b11998555631f66" ? null : (
                  <div className="company-dates">
                    <span>Created By : {clientCreatedUserName}</span>
                  </div>
                )}
              </div>
            )}
            {isEditingClient ? (
              <>
                <Button
                  label="Save"
                  event={saveClientChanges}
                  style={{ padding: "8px 15px" }}
                  backgroundColor="#6860EE"
                  color="#FFFFFF"
                  border="none"
                />
                <Button
                  label="Cancel"
                  event={handleCancelEditClient}
                  style={{ padding: "8px 15px" }}
                  backgroundColor="#fff"
                  color="#000"
                  border="1px solid #ddd"
                />
              </>
            ) : (
              <CustomTooltip title={`Edit ${tenantLabel}`} arrow>
                <img
                  src={editIcon}
                  alt="Edit"
                  onClick={handleEditClient}
                  style={{ cursor: "pointer", width: "22px" }}
                />
              </CustomTooltip>
            )}
            {!isEditingClient && !MemberAccess && (
              <CustomTooltip title={`Delete ${tenantLabel}`} arrow>
                <img
                  src={deleteIcon}
                  alt="Delete"
                  onClick={handleOpenClientDeleteDialog}
                  style={{ cursor: "pointer", width: "22px" }}
                />
              </CustomTooltip>
            )}
          </div>
        }
      >
        {selectedClient && (
          <div className="client-main-container">
            {isEditingClient && (
              <div className="client-name-edit">
                <TextInput
                  label={
                    isHiringTeamTenant ? "Hiring Team Name" : "Client Name"
                  }
                  name="clientName"
                  placeholder={
                    isHiringTeamTenant ? "Hiring Team Name" : "Client Name"
                  }
                  required={true}
                  onBlur={formik.handleBlur}
                  error={formik.touched.clientName && formik.errors.clientName}
                  errorMessage={formik.errors.clientName}
                  value={formik.values.clientName}
                  onChange={formik.handleChange}
                />
              </div>
            )}
            <div
              style={{
                padding: "0px",
                display: "flex",
                flexDirection: "column",
                gap: "20px",
              }}
            >
              <div
                className={`client-candidate-info-outer-container ${
                  isEditingClient ? "edit-mode" : ""
                }`}
              >
                <div className="candidate-information">
                  <div className="info-header">
                    <img
                      src={accountIcon}
                      alt="company-icon"
                      style={{ width: "20px", height: "20px" }}
                    />
                    <h4 className="info-header-value">
                      Contact Person{" "}
                      {isEditingClient && (
                        <span style={{ color: "red" }}>*</span>
                      )}
                    </h4>
                  </div>

                  <div className="detail-content">
                    {isEditingClient ? (
                      <TextInput
                        placeholder="Contact Person"
                        name="contactPerson"
                        value={formik.values.contactPerson}
                        required={true}
                        onBlur={formik.handleBlur}
                        error={
                          formik.touched.contactPerson &&
                          formik.errors.contactPerson
                        }
                        errorMessage={formik.errors.contactPerson}
                        onChange={formik.handleChange}
                      />
                    ) : (
                      <span className="candidate-email">
                        {selectedClient?.contact_person || "N/A"}
                      </span>
                    )}
                  </div>
                </div>
                <div className="candidate-information">
                  <div className="info-header">
                    <img
                      src={jobIcon}
                      alt="job-icon"
                      style={{ width: "20px", height: "20px" }}
                    />
                    <h4 className="info-header-value">
                      Contact Designation{" "}
                      {isEditingClient && (
                        <span style={{ color: "red" }}>*</span>
                      )}
                    </h4>
                  </div>

                  <div className="detail-content">
                    {isEditingClient ? (
                      <TextInput
                        name="contactDesignation"
                        placeholder="Designation"
                        value={formik.values.contactDesignation}
                        required={true}
                        onBlur={formik.handleBlur}
                        error={
                          formik.touched.contactDesignation &&
                          formik.errors.contactDesignation
                        }
                        errorMessage={formik.errors.contactDesignation}
                        onChange={formik.handleChange}
                      />
                    ) : (
                      <span className="candidate-email">
                        {selectedClient?.contact_designation || "N/A"}
                      </span>
                    )}
                  </div>
                </div>
                <div className="candidate-information">
                  <div className="info-header">
                    <img
                      src={mailIcon}
                      alt="mail-icon"
                      style={{ width: "20px", height: "20px" }}
                    />
                    <h4 className="info-header-value">
                      Email{" "}
                      {isEditingClient && (
                        <span style={{ color: "red" }}>*</span>
                      )}
                    </h4>
                  </div>
                  <div className="detail-content">
                    {isEditingClient ? (
                      <TextInput
                        placeholder="Email"
                        name="email"
                        type="email"
                        value={formik.values.email}
                        required={true}
                        onBlur={formik.handleBlur}
                        error={formik.touched.email && formik.errors.email}
                        errorMessage={formik.errors.email}
                        onChange={formik.handleChange}
                      />
                    ) : (
                      <h5 className="client-details-value">
                        {selectedClient?.email || "N/A"}
                      </h5>
                    )}
                  </div>
                </div>
                <div className="candidate-information">
                  <div className="info-header">
                    <img
                      src={phoneIcon}
                      alt="phone-icon"
                      style={{ width: "20px", height: "20px" }}
                    />
                    <h4 className="info-header-value">
                      Phone{" "}
                      {isEditingClient && (
                        <span style={{ color: "red" }}>*</span>
                      )}
                    </h4>
                  </div>
                  <div className="detail-content">
                    {isEditingClient ? (
                      <PhoneNumberInput
                        value={formik.values.mobile}
                        onChange={handlePhoneInputChange}
                        onBlur={formik.handleBlur}
                        error={formik.errors.mobile}
                        touched={formik.touched.mobile}
                        placeholder="e.g. (415) 555-0198"
                        width="100%"
                        height="40px"
                        countryListWidth="300px"
                        phoneContainerStyle={{ marginBottom: "15px" }}
                        required={true}
                      />
                    ) : (
                      <h5 className="client-details-value">
                        {selectedClient?.phone || "N/A"}
                      </h5>
                    )}
                  </div>
                </div>
                <div className="candidate-information">
                  <div className="info-header">
                    <img
                      src={jobIcon}
                      alt="job-icon"
                      style={{ width: "20px", height: "20px" }}
                    />
                    <h4 className="info-header-value">
                      {isHiringTeamTenant ? "Division" : "Client Type"}
                    </h4>
                  </div>

                  <div className="detail-content">
                    {isEditingClient ? (
                      <TextInput
                        name="clientType"
                        placeholder={
                          isHiringTeamTenant
                            ? "e.g. Frontend Team, Backend Team"
                            : "e.g. Enterprise, Startup"
                        }
                        required={false}
                        onBlur={formik.handleBlur}
                        error={
                          formik.touched.clientType &&
                          formik.errors.clientType
                        }
                        errorMessage={formik.errors.clientType}
                        value={formik.values.clientType}
                        onChange={formik.handleChange}
                      />
                    ) : (
                      <span className="candidate-email">
                        {selectedClient?.client_type || "N/A"}
                      </span>
                    )}
                  </div>
                </div>
              </div>
              <div className="client-details-container">
                <div className="client-details-inner-container">
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                      alignItems: "center",
                      padding: 0,
                      gap: "48px",
                      marginBottom: "20px",
                    }}
                  >
                    <div className="info-header">
                      <img
                        src={locationIcon}
                        alt="location-icon"
                        style={{ width: "20px", height: "20px" }}
                      />
                      <span
                        className="detail-label"
                        style={{
                          color: "#6a69eb",
                          fontSize: "20px",
                          fontWeight: "500",
                        }}
                      >
                        {isHiringTeamTenant
                          ? "Hiring Team Location Details"
                          : "Client Location Details"}{" "}
                      </span>
                    </div>
                  </div>
                  <div className="candidate-information">
                    <div className="detail-content">
                      {isEditingClient ? (
                        <>
                          <div className="location-inputs">
                            <TextInput
                              label="Address Line 1"
                              name="address1"
                              placeholder="Enter your address Line 1"
                              value={formik.values.address1}
                              onBlur={formik.handleBlur}
                              error={
                                formik.touched.address1 &&
                                formik.errors.address1
                              }
                              errorMessage={formik.errors.address1}
                              onChange={formik.handleChange}
                            />
                            <TextInput
                              label="Address Line 2 (Optional)"
                              name="address2"
                              placeholder="Enter your address line 2"
                              value={formik.values.address2}
                              onBlur={formik.handleBlur}
                              error={
                                formik.touched.address2 &&
                                formik.errors.address2
                              }
                              errorMessage={formik.errors.address2}
                              onChange={formik.handleChange}
                            />
                          </div>
                          <div className="location-inputs">
                            <TextInput
                              label="City"
                              name="city"
                              placeholder="City"
                              value={formik.values.city}
                              onBlur={formik.handleBlur}
                              error={formik.touched.city && formik.errors.city}
                              errorMessage={formik.errors.city}
                              onChange={formik.handleChange}
                            />
                            <TextInput
                              label="State"
                              name="state"
                              placeholder="State"
                              value={formik.values.state}
                              onBlur={formik.handleBlur}
                              error={
                                formik.touched.state && formik.errors.state
                              }
                              errorMessage={formik.errors.state}
                              onChange={formik.handleChange}
                            />
                            <TextInput
                              label="Country"
                              name="country"
                              placeholder="Country"
                              value={formik.values.country}
                              onBlur={formik.handleBlur}
                              error={
                                formik.touched.country &&
                                formik.errors.country
                              }
                              errorMessage={formik.errors.country}
                              onChange={formik.handleChange}
                            />
                            <TextInput
                              label="Zipcode"
                              name="zipCode"
                              placeholder="Zipcode"
                              value={formik.values?.zipCode}
                              onBlur={formik.handleBlur}
                              error={
                                formik.touched.zipCode &&
                                formik.errors.zipCode
                              }
                              errorMessage={formik.errors.zipCode}
                              onChange={formik.handleChange}
                            />
                          </div>
                        </>
                      ) : (
                        <>
                          <div className="address-outer-container">
                            <div className="address-containers">
                              <label>Address Line 1: </label>
                              <h5 className="client-details-value">
                                {selectedClient?.address || "N/A"}
                              </h5>
                            </div>
                            {selectedClient?.address_2 && (
                              <div className="address-containers">
                                <label>Address Line 2: </label>
                                <h5 className="client-details-value">
                                  {selectedClient?.address_2 || "N/A"}
                                </h5>
                              </div>
                            )}

                            <div className="address-containers">
                              <label>City : </label>
                              <h5 className="client-details-value">
                                {selectedClient?.city || "N/A"}
                              </h5>
                            </div>
                            <div className="address-containers">
                              <label>State : </label>
                              <h5 className="client-details-value">
                                {selectedClient?.state || "N/A"}
                              </h5>
                            </div>
                            <div className="address-containers">
                              <label>Country : </label>
                              <h5 className="client-details-value">
                                {selectedClient?.country || "N/A"}
                              </h5>
                            </div>
                            <div className="address-containers">
                              <label>Zipcode : </label>
                              <h5 className="client-details-value">
                                {selectedClient?.zip_code || "N/A"}
                              </h5>
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              <div className="client-tabs-container">
                <div
                  className={`tab ${
                    activeTab === "Jobs" ? "job-tab-active" : ""
                  }`}
                  onClick={() => setActiveTab("Jobs")}
                >
                  Jobs
                </div>
                <div
                  className={`tab ${
                    activeTab === "Tracking" ? "job-tab-active" : ""
                  }`}
                  onClick={() => setActiveTab("Tracking")}
                >
                  Tracking
                </div>
                {!isHiringTeamTenant && (
                  <div
                    className={`tab ${
                      activeTab === "Additional Contacts"
                        ? "job-tab-active"
                        : ""
                    }`}
                    onClick={() => setActiveTab("Additional Contacts")}
                  >
                    Additional Contacts
                  </div>
                )}
                <div
                  className={`tab ${activeTab === "Documents" ? "job-tab-active" : ""}`}
                  onClick={() => setActiveTab("Documents")}
                >
                  Documents
                </div>
              </div>
            </div>
            <ContentDialog
              isOpen={showClientContactPopup}
              onClose={handleCloseContactPopup}
              onCloseIconClose={handleCloseContactPopup}
              submitButtonLabel="Add"
              cancelButtonLabel="Cancel"
              event={contactFormik.handleSubmit}
              contentWidth="45vw"
              contentHeight={"auto"}
              title={`Add ${tenantLabel} Contact`}
            >
              <div
                className="add-client-contact-container"
                style={{ padding: "25px" }}
              >
                <DynamicTextField
                  label="Contact Person Name"
                  type="text"
                  name="contactName"
                  placeholder="e.g. Alicia Carter."
                  value={contactFormik.values.contactName}
                  onChange={contactFormik.handleChange}
                  onBlur={contactFormik.handleBlur}
                  error={
                    contactFormik.touched.contactName &&
                    contactFormik.errors.contactName
                  }
                  errorMessage={contactFormik.errors.contactName}
                  style={{ width: "100%" }}
                  labelStyle={{ marginBottom: "10px" }}
                  required={true}
                />
                <DynamicTextField
                  label="Contact Person Email"
                  type="email"
                  name="contactEmail"
                  placeholder="e.g. marcus.nguyen@strivetech.com"
                  value={contactFormik.values.contactEmail}
                  onChange={contactFormik.handleChange}
                  onBlur={contactFormik.handleBlur}
                  error={
                    contactFormik.touched.contactEmail &&
                    contactFormik.errors.contactEmail
                  }
                  errorMessage={contactFormik.errors.contactEmail}
                  required={true}
                  labelStyle={{ marginBottom: "10px" }}
                />
                <PhoneNumberInput
                  value={contactFormik.values.contactPhoneNumber}
                  onChange={handleContactPhoneInputChange}
                  onBlur={() =>
                    contactFormik.setFieldTouched("contactPhoneNumber", true)
                  }
                  error={contactFormik.errors.contactPhoneNumber}
                  touched={contactFormik.touched.contactPhoneNumber}
                  placeholder="e.g. (415) 555-0198"
                  label="Contact Person Contact No."
                  width="100%"
                  height="40px"
                  countryListWidth="300px"
                  phoneContainerStyle={{ marginBottom: "15px" }}
                  required={true}
                />
                <DynamicTextField
                  label="Contact Person Designation"
                  type="text"
                  name="contactDesignation"
                  placeholder={
                    isHiringTeamTenant
                      ? "e.g. Hiring Manager"
                      : "e.g. Technical Recruiter"
                  }
                  value={contactFormik.values.contactDesignation}
                  onChange={contactFormik.handleChange}
                  onBlur={contactFormik.handleBlur}
                  error={
                    contactFormik.touched.contactDesignation &&
                    contactFormik.errors.contactDesignation
                  }
                  errorMessage={contactFormik.errors.contactDesignation}
                  style={{ width: "100%" }}
                  labelStyle={{ marginBottom: "10px" }}
                  required={true}
                />
                <DynamicTextField
                  label="Contact Person Location"
                  type="text"
                  name="contactLocation"
                  placeholder="e.g. New York, USA"
                  value={contactFormik.values.contactLocation}
                  onChange={contactFormik.handleChange}
                  onBlur={contactFormik.handleBlur}
                  error={
                    contactFormik.touched.contactLocation &&
                    contactFormik.errors.contactLocation
                  }
                  errorMessage={contactFormik.errors.contactLocation}
                  style={{ width: "100%" }}
                  labelStyle={{ marginBottom: "10px" }}
                  required={true}
                />
              </div>
            </ContentDialog>
            <ContentDialog
              isOpen={showEditContactPopup}
              onClose={handleCloseContactPopup}
              onCloseIconClose={handleCloseContactPopup}
              submitButtonLabel={isViewingContact ? null : "Update"}
              cancelButtonLabel={isViewingContact ? "Close" : "Cancel"}
              event={isViewingContact ? null : contactFormik.handleSubmit}
              showActionButton={!isViewingContact}
              contentWidth="45vw"
              title={
                isViewingContact
                  ? `View ${tenantLabel} Contact`
                  : `Edit ${tenantLabel} Contact`
              }
            >
              <div
                className={`add-client-contact-container ${
                  isViewingContact ? "view-contact-details-container" : ""
                }`}
                style={{ padding: "25px" }}
              >
                {isViewingContact ? (
                  <>
                    {[
                      {
                        icon: accountIcon,
                        label: "Contact Person Name",
                        value: contactFormik.values.contactName,
                      },
                      {
                        icon: mailIcon,
                        label: "Contact Person Email",
                        value: contactFormik.values.contactEmail,
                      },
                      {
                        icon: phoneIcon,
                        label: "Contact Person Contact No.",
                        value: contactFormik.values.contactPhoneNumber,
                      },
                      {
                        icon: jobIcon,
                        label: "Contact Person Designation",
                        value: contactFormik.values.contactDesignation,
                      },
                      {
                        icon: locationViewIcon,
                        label: "Contact Person Location",
                        value: contactFormik.values.contactLocation,
                      },
                    ].map((detail) => (
                      <div
                        className="view-contact-detail-item"
                        key={detail.label}
                      >
                        <div className="view-contact-detail-label">
                          <img src={detail.icon} alt="" />
                          <span>{detail.label}</span>
                        </div>
                        <p className="view-contact-detail-value">
                          {detail.value || "N/A"}
                        </p>
                      </div>
                    ))}
                  </>
                ) : (
                  <>
                    <DynamicTextField
                      label="Contact Person Name"
                      type="text"
                      name="contactName"
                      placeholder="e.g. Alicia Carter."
                      value={contactFormik.values.contactName}
                      onChange={contactFormik.handleChange}
                      onBlur={contactFormik.handleBlur}
                      error={
                        contactFormik.touched.contactName &&
                        contactFormik.errors.contactName
                      }
                      errorMessage={contactFormik.errors.contactName}
                      style={{ width: "100%" }}
                      labelStyle={{ marginBottom: "10px" }}
                      required={true}
                    />
                    <DynamicTextField
                      label="Contact Person Email"
                      type="email"
                      name="contactEmail"
                      placeholder="e.g. marcus.nguyen@strivetech.com"
                      value={contactFormik.values.contactEmail}
                      onChange={contactFormik.handleChange}
                      onBlur={contactFormik.handleBlur}
                      error={
                        contactFormik.touched.contactEmail &&
                        contactFormik.errors.contactEmail
                      }
                      errorMessage={contactFormik.errors.contactEmail}
                      required={true}
                      labelStyle={{ marginBottom: "10px" }}
                    />
                    <PhoneNumberInput
                      value={contactFormik.values.contactPhoneNumber}
                      onChange={handleContactPhoneInputChange}
                      onBlur={() =>
                        contactFormik.setFieldTouched(
                          "contactPhoneNumber",
                          true,
                        )
                      }
                      error={contactFormik.errors.contactPhoneNumber}
                      touched={contactFormik.touched.contactPhoneNumber}
                      placeholder="e.g. (415) 555-0198"
                      label="Contact Person Contact No."
                      width="100%"
                      height="40px"
                      countryListWidth="300px"
                      phoneContainerStyle={{ marginBottom: "15px" }}
                      required={true}
                    />
                    <DynamicTextField
                      label="Contact Person Designation"
                      type="text"
                      name="contactDesignation"
                      placeholder={
                        isHiringTeamTenant
                          ? "e.g. Hiring Manager"
                          : "e.g. Technical Recruiter"
                      }
                      value={contactFormik.values.contactDesignation}
                      onChange={contactFormik.handleChange}
                      onBlur={contactFormik.handleBlur}
                      error={
                        contactFormik.touched.contactDesignation &&
                        contactFormik.errors.contactDesignation
                      }
                      errorMessage={contactFormik.errors.contactDesignation}
                      style={{ width: "100%" }}
                      labelStyle={{ marginBottom: "10px" }}
                      required={true}
                    />
                    <DynamicTextField
                      label="Contact Person Location"
                      type="text"
                      name="contactLocation"
                      placeholder="e.g. New York, USA"
                      value={contactFormik.values.contactLocation}
                      onChange={contactFormik.handleChange}
                      onBlur={contactFormik.handleBlur}
                      error={
                        contactFormik.touched.contactLocation &&
                        contactFormik.errors.contactLocation
                      }
                      errorMessage={contactFormik.errors.contactLocation}
                      style={{ width: "100%" }}
                      labelStyle={{ marginBottom: "10px" }}
                      required={true}
                    />
                  </>
                )}
              </div>
            </ContentDialog>

            <ContentDialog
              isOpen={showDeleteContactPopup}
              onClose={() => {
                setShowDeleteContactPopup(false);
                setSelectedContact(null);
              }}
              onCloseIconClose={() => {
                setShowDeleteContactPopup(false);
                setSelectedContact(null);
              }}
              submitButtonLabel="Delete"
              cancelButtonLabel="Cancel"
              event={handleDeleteClientContactDetails}
              contentWidth="40vw"
              contentHeight={"auto"}
              title={"Delete Contact"}
            >
              <div style={{ padding: "25px", textAlign: "center" }}>
                <p>Are you sure you want to delete this contact?</p>
                <p>
                  <strong>{selectedContact?.name}</strong> -{" "}
                  {selectedContact?.email}
                </p>
                <p
                  style={{
                    color: "#666",
                    fontSize: "14px",
                    marginTop: "10px",
                  }}
                >
                  This action cannot be undone.
                </p>
              </div>
            </ContentDialog>
            <div className="client-details-content-container">
              {renderContent()}
            </div>
          </div>
        )}
      </SidePopup>
      <ConfirmationPopup
        isOpen={isClientDeleteDialogOpen}
        onClose={() => setIsClientDeleteDialogOpen(false)}
        onConfirm={handleDeleteClient}
        title={`Delete ${tenantLabel}?`}
        subTitle="Confirmation required"
        message={
          <span>
            You are about to delete{" "}
            <span
              style={{
                color: "#6665ea",
                fontWeight: "bold",
              }}
            >
              "{applyEllipsis(selectedClient?.name, 35)}"
            </span>
            , This action will permanently remove this {tenantLabelLower}{" "}
            details, including associated jobs and related data.
            <br />
            <br />
            This action cannot be undone. Are you sure you want to delete?
          </span>
        }
        cancelLabel="No, Cancel"
        confirmLabel="Yes, Delete"
        confirmButtonClass="popup-button-danger"
      />
      {selectedJobDetails && (
        <JobsDetailsContainer
          isOpen={jobsSideContainerOpen}
          onClose={handleCloseJobDetailsContainer}
          selectedJob={selectedJobDetails}
          isEditingJob={isEditingJob}
          setIsEditingJob={setIsEditingJob}
          activeTab={jobDetailsActiveTab}
          setActiveTab={setJobDetailsActiveTab}
          formik={jobEditFormik}
          sideDialogformik={sideDialogformik}
          editedJobData={editedJobData}
          handleEditJob={handleEditJob}
          handleJobChange={handleJobChange}
          saveJobChanges={saveJobChanges}
          handleDeleteJob={handleOpenDeleteJobDialog}
          assignedCount={assignedCount}
          setAssignedCount={setAssignedCount}
          onAssignedCountChange={setAssignedCount}
          isFetchingRecommendedCandidates={isFetchingRecommendedCandidates}
          resetJobEdit={resetJobEdit}
          jobId={selectedJobDetails?.id}
        />
      )}
      <ConfirmationPopup
        isOpen={openJobDeleteDialog}
        onClose={() => setOpenJobDeleteDialog(false)}
        onConfirm={handleDeleteJob}
        title="Delete Job?"
        subTitle="Confirmation required"
        message={
          <span>
            This will delete{" "}
            <span
              style={{
                color: "#6665ea",
                fontWeight: "bold",
              }}
            >
              "{applyEllipsis(selectedJobDetails?.title, 35)}"
            </span>
            Are you sure you want to delete this job? This action cannot be
            undone.
          </span>
        }
        cancelLabel="No, Cancel"
        confirmLabel="Yes, Delete"
        confirmButtonClass="popup-button-danger"
      />
    </>
  );
}

export default ClientXLResults;
